// extracted by mini-css-extract-plugin
export default {"img_wrapper":"DoneServices_img_wrapper__Gu2xC","second_section_heading":"DoneServices_second_section_heading__Pk0LO"};